/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetCompanyWaProfileImage$Params {
  wabaPhoneId: string;
}

export function getCompanyWaProfileImage(http: HttpClient, rootUrl: string, params: GetCompanyWaProfileImage$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, getCompanyWaProfileImage.PATH, 'get');
  if (params) {
    rb.path('wabaPhoneId', params.wabaPhoneId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'image/jpeg', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

getCompanyWaProfileImage.PATH = '/v1/api/ui/public/company/wa-profile/{wabaPhoneId}/image';
